import { Box, Chip } from '@mui/material';
import TagsProps from '../../interfaces/props/TagsProps';
import classes from './Tags.module.scss';
import { Tag } from '../../interfaces/Tag';
import { TagTypes } from '../../enums/TagTypes';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import StadiumIcon from '@mui/icons-material/Stadium';
import PersonIcon from '@mui/icons-material/Person';
import ShieldIcon from '@mui/icons-material/Shield';
import ClearIcon from '@mui/icons-material/Clear';
import { useCallback, useMemo } from 'react';

const SMALL_SIZE = 'small';

const Tags = ({ tags, onTagClick, onDelete, lightColored }: TagsProps) => {
  const tagClickHandler = (tag: Tag) => {
    if (onTagClick) {
      onTagClick(tag);
    }
  };

  const deleteHandler = (tag: Tag) => {
    if (onDelete) {
      onDelete(tag);
    }
  };

  const setTagName = useCallback((tag: Tag) => {
    let name = tag.attributes.name;

    if (tag.attributes.sport) {
      name = `${name} (${tag.attributes.sport})`;
    }

    if (tag.attributes.gender) {
      switch (tag.attributes.gender) {
        case 'male':
          name += ' M';
          break;
        case 'female':
          name += ' W';
          break;
      }
    }

    return name;
  }, []);

  const resolvedTags = useMemo(() => {
    return tags.filter(tag => null !== tag.attributes.tagger_id);
  }, [tags]);

  const typeToIcon: Record<TagTypes, JSX.Element> = {
    [TagTypes.TEMPLATE]: <EmojiEventsIcon fontSize={SMALL_SIZE} />,
    [TagTypes.SPORT]: <SportsSoccerIcon fontSize={SMALL_SIZE} />,
    [TagTypes.DATE]: <CalendarMonthIcon fontSize={SMALL_SIZE} />,
    [TagTypes.PLAYER]: <PersonIcon fontSize={SMALL_SIZE} />,
    [TagTypes.VENUE]: <StadiumIcon fontSize={SMALL_SIZE} />,
    [TagTypes.COACH]: <PersonIcon fontSize={SMALL_SIZE} />,
    [TagTypes.TEAM]: <ShieldIcon fontSize={SMALL_SIZE} />,
    [TagTypes.NO_TAG]: <></>
  };

  return (
    <Box>
      {resolvedTags.map((tag) => (
        <Chip
          key={tag.id}
          className={`m-1 ${lightColored ? classes.lightColoredTag : classes.tag}`}
          label={setTagName(tag)}
          variant='outlined'
          deleteIcon={onDelete ? <ClearIcon /> : <></>}
          onDelete={() => deleteHandler(tag)}
          onClick={() => tagClickHandler(tag)}
          icon={typeToIcon[tag.attributes.type]}
        />
      ))}
    </Box>
  );
};

export default Tags;
